// Client for the Keyword Optimiser.
//
// Reads, plus the seller's own decisions. The apply call is a dry run by
// default and is refused outright while writing to Amazon is switched off — the
// response says which locks are closed.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/keyword-optimiser`;

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class NotConnectedError extends Error {
  constructor(message) {
    super(message || 'Amazon Ads not connected');
    this.notConnected = true;
  }
}

const call = async (url, options) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }
  if (data.connected === false) throw new NotConnectedError(data.reason);
  return data;
};

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.set(k, v);
  });
  return search.toString();
};

export const getOverview = (token, params) =>
  call(`${BASE}/overview?${query(params)}`, { headers: headers(token) });
export const getSuggestions = (token, params) =>
  call(`${BASE}/suggestions?${query(params)}`, { headers: headers(token) });
export const getChanges = (token, params) =>
  call(`${BASE}/changes?${query(params)}`, { headers: headers(token) });
export const getBrands = (token) =>
  call(`${BASE}/brands`, { headers: headers(token) });
export const saveBrands = (token, body) =>
  call(`${BASE}/brands`, { method: 'POST', headers: headers(token),
    body: JSON.stringify(body) });

export const discover = (token, asins) =>
  call(`${BASE}/discover`, { method: 'POST', headers: headers(token),
    body: JSON.stringify({ asins }) });
export const getPlan = (token, asins) =>
  call(`${BASE}/plan?${query({ asins: asins.join(',') })}`,
    { headers: headers(token) });

export const decide = (token, id, decision, body) =>
  call(`${BASE}/suggestions/${encodeURIComponent(id)}/${decision}`,
    { method: 'POST', headers: headers(token), body: JSON.stringify(body || {}) });
export const approveMany = (token, ids) =>
  call(`${BASE}/approve`, { method: 'POST', headers: headers(token),
    body: JSON.stringify({ ids }) });
export const applyOne = (token, id, dryRun = true) =>
  call(`${BASE}/suggestions/${encodeURIComponent(id)}/apply`,
    { method: 'POST', headers: headers(token),
      body: JSON.stringify({ dry_run: dryRun }) });
export const undoOne = (token, id, dryRun = true) =>
  call(`${BASE}/suggestions/${encodeURIComponent(id)}/undo`,
    { method: 'POST', headers: headers(token),
      body: JSON.stringify({ dry_run: dryRun }) });
export const markIntentional = (token, pair, remove) =>
  call(`${BASE}/intentional`, { method: 'POST', headers: headers(token),
    body: JSON.stringify({ pair, remove }) });
